import React, { Component } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import style from './subscribe.module.scss'

export default class Subscribtion extends Component {
  state = {
    email: '',
    isSubscribed: false,
  }
  handleChange = e => {
    this.setState({
      [`${e.target.name}`]: e.target.value,
    })
  }
  handleSubmit = e => {
    e.preventDefault()

    addToMailchimp(this.state.email) // listFields are optional if you are only capturing the email address.
      .then(data => {
        // I recommend setting data to React state
        // but you can do whatever you want (including ignoring this `then()` altogether)
        this.setState({ isSubscribed: true })
      })
      .catch(() => {
        // unnecessary because Mailchimp only ever
        // returns a 200 status code
        // see below for how to handle errors
      })
  }

  render() {
    return (
      <div className={style.mainDiv}>
        <div className={style.textBox}>
          {this.state.isSubscribed === true ? (
            <p className={style.text}>Thank You for subscribing</p>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <p className={style.newsletterText}>Subscribe To My NewsLetter</p>
              <input
                type="email"
                className={style.emailInput}
                placeholder="Enter your e-mail address"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
              />
              <button type="submit" className={style.btnSubmit}>
                Send
              </button>
            </form>
          )}
        </div>
      </div>
    )
  }
}

/* import React from 'react'
import style from './subscribe.module.scss'

const Subscribtion = () => {
  return (
    <div className="mainDiv">
      <input
        type="email"
        placeholder="E-mail"
        aria-label="email-field"
        className={style.emailInput}
      />
      <button type="submit" className={style.btnSubmit}>
        Send
      </button>
    </div>
  )
}

export default Subscribtion
 */
